import * as React from 'react'
import PropTypes from 'prop-types'
import { dataProps } from '@ds/react-utils'
import { useIsInk, useThemeStyles } from '../../../theming'
import { BaseHeading } from '../../../internal/components/BaseHeading'
import styles from './styles'

export interface ModalHeaderProps {
  /**
   * The subtitle to display in the modal header.
   */
  subtitle?: string
  /**
   * The title to display in the modal header.
   */
  title: string
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
}

export function ModalHeader({
  'data-qa': dataQa,
  subtitle,
  title,
  ...restProps
}: ModalHeaderProps) {
  const sx = useThemeStyles(styles)

  return (
    <div {...dataProps(restProps)} data-qa={dataQa} css={sx.default.header}>
      <BaseHeading
        data-qa={dataQa && `${dataQa}-heading`}
        level="2"
        text={title}
        displayLevel={useIsInk() ? 'heading-m' : 'heading-l'}
      />
      {subtitle && (
        <p css={sx.default.subtitle} data-qa={dataQa && `${dataQa}-subtitle`}>
          {subtitle}
        </p>
      )}
    </div>
  )
}

ModalHeader.displayName = 'Modal.Header'

ModalHeader.propTypes = {
  'data-.*': PropTypes.string,
  title: PropTypes.string.isRequired,
}
